/* StileVivo scroll reveals. Progressive enhancement; content never depends on JS to appear. */
(() => {
  'use strict';
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  if (reduced?.matches || !('IntersectionObserver' in window) || !('animate' in Element.prototype)) return;

  const selector = [
    '#MainContent product-card',
    '#MainContent h1',
    '#MainContent .section-heading',
    '#MainContent .rich-text h2',
    '#MainContent .multicolumn-card'
  ].join(', ');

  const seen = new WeakSet();
  let cards = 0;

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      const element = entry.target;
      if (seen.has(element) || !element.isConnected) continue;
      seen.add(element);
      const isCard = element.localName === 'product-card';
      const delay = isCard ? (cards++ % 4) * 150 : 60;
      element.animate(
        [
          { opacity: 0.08, translate: '0 28px' },
          { opacity: 1, translate: '0 0' }
        ],
        {
          duration: isCard ? 1250 : 1450,
          delay,
          easing: 'cubic-bezier(.22,.61,.36,1)',
          fill: 'backwards'
        }
      );
    }
  }, { threshold: .17, rootMargin: '0px 0px -9% 0px' });

  function observeElements(root) {
    const elements = [];
    if (root.matches?.(selector)) elements.push(root);
    root.querySelectorAll?.(selector).forEach((element) => elements.push(element));
    for (const element of elements) {
      if (seen.has(element) || element.hasAttribute('hidden')) continue;
      if (element.closest('[aria-hidden="true"], [inert], dialog:not([open])')) continue;
      observer.observe(element);
    }
  }

  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    observeElements(main);

    /* Collection filters and Shopify sections can swap product cards later. */
    let pending = false;
    const changes = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        observeElements(main);
      });
    });
    changes.observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => {
      if (main.contains(event.target)) observeElements(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
